export default {
  name: "Name des Teilnehmers",
  role: "Rolle des Teilnehmers",
};
